module.exports = __webpack_public_path__ + "static/media/refresh-white.f3882ccc.svg";